import UpdateUom from "../../../../components/@products/uoms/UpdateUom";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UomUpdatePage() {

    return (
        <UpdateUom 
            routeType={routeTypes.admin}
        />
    )
}       